function initialState() {
  return {};
}

const mutations = {
  // updateMenu(state, items) {
  //   state.items = items;
  // }
};

const actions = {
  // setMenu(state, items) {
  //   state.commit("updateMenu", items);
  // }
};

const namespaced = true;

const prova = {
  namespaced,
  state: initialState(),
  actions,
  mutations
};

export default prova;



// WEBPACK FOOTER //
// ./src/store/prova.js